import React, { useRef, useState } from 'react'
import { Drawer } from 'antd'
import { TableComp } from 'sz-react-utils-lite'
import { getAllFutureWithdrawals } from '../actions/user'
import moment from 'moment'
import { useDispatch } from 'react-redux'

const FutureDateWithdrawalList = (props) => {
  let { visible, onClose, countryId, name } = props
  const dispatch = useDispatch()
  const tableRef2 = useRef()
  const [total, setTotal] = useState(0)
  const apiRequest = (params) => {
    return new Promise(async (resolve) => {
      params.countryId = countryId
      params.withdrawalReleaseDate = { $exists: true }
      params.withdrawalLimitId = { $exists: false }
      let { data } = await dispatch(getAllFutureWithdrawals(params))
      setTotal(data.total)
      resolve(data)
    })
  }
  const columns = [
    {
      title: <div style={{ fontSize: '18px', fontWeight: 700 }}>Sr. No</div>,
      key: '_id',
      dataIndex: '_id',
      width: 80,
      render: function(text, record, index) {
        return (
          <div
            style={{
              fontSize: '18px',
              fontWeight: 600,
              color: '#096dd9',
              padding: '8px 0'
            }}
          >
            {index + 1}
          </div>
        )
      }
    },
    {
      title: 'Amount',
      key: 'amount',
      dataIndex: 'amount',
      width: 80,
      render: (item, record) => {
        return <div
          style={{ width: 80 }}>{record && record.countryId && record.countryId.currency && record.countryId.currency}{item}</div>
      }
    },
    {
      title: 'Agent',
      key: 'agentId',
      dataIndex: 'agentId',
      width: 150,
      render: item => {
        return <div>{item && item.companyName && item.companyName} ({item && item.name && item.name})</div>
      }
    },
    {
      title: 'Country',
      key: 'countryId',
      dataIndex: 'countryId',
      width: 80,
      render: item => {
        return <div style={{ width: 80 }}>{item && item.countryName && item.countryName}</div>
      }
    },
    {
      title: 'Release Date',
      key: 'withdrawalReleaseDate',
      dataIndex: 'withdrawalReleaseDate',
      width: 80,
      render: item => {
        return <div style={{ width: 80 }}>{item ? moment(item).format('DD-MM-YYYY') : '--'}</div>
      }
    }
  ]


  return (
    <>
      <Drawer title={`${name} Future Withdrawal List (${total})`} width={'50%'} onClose={onClose} visible={visible}>
        <div className={'card'}>
          <div className='card-body table-responsive'>
            <TableComp
              columns={columns}
              ref={tableRef2}
              apiRequest={apiRequest}
            />
          </div>
        </div>
      </Drawer>
    </>
  )
}
export default FutureDateWithdrawalList
